import React from 'react';
import cx from 'classnames';
import { defaultStyles, Tooltip } from '@visx/tooltip';
import { Icon } from 'js/components';
import {
  formatTrendScorePercent,
  formatTrendTooltipDate,
  TREND_TOOLTIP_MAX_WIDTH,
} from 'js/utils/org-trends';
import {
  orgTrendLineKindLabel,
  orgTrendLineKindPaletteClass,
} from 'js/utils/org-trends-rollup';

import styles from './OrgTrendsLineTooltip.module.scss';

export function OrgTrendsLineTooltipContent({
  label,
  isRollup,
  depth = 0,
  score,
  date,
}) {
  const kindPaletteClass = orgTrendLineKindPaletteClass({ isRollup, depth });
  const kindLabel = orgTrendLineKindLabel({ isRollup, depth });
  const scorePercent = formatTrendScorePercent(score);
  const pointDate = formatTrendTooltipDate(date);
  const hasMeta = pointDate != null || scorePercent != null;

  return (
    <div className={styles.content}>
      <div className={styles.name}>{label}</div>
      {hasMeta && (
        <div className={styles.meta}>
          {pointDate != null && <span>{pointDate}</span>}
          {pointDate != null && scorePercent != null && (
            <span className={styles.metaSeparator}>·</span>
          )}
          {scorePercent != null && <span>{scorePercent}%</span>}
        </div>
      )}
      <div className={cx('text-only', kindPaletteClass, styles.kind)}>
        <Icon
          icon={isRollup ? 'sitemap' : 'users'}
          fixedWidth
          className={styles.kindIcon}
        />
        {kindLabel}
      </div>
    </div>
  );
}

export default function OrgTrendsLineTooltip({
  top,
  left,
  transform,
  ...contentProps
}) {
  return (
    <Tooltip
      top={top}
      left={left}
      offsetLeft={null}
      offsetTop={null}
      className={styles.tooltip}
      style={{
        ...defaultStyles,
        transform,
        maxWidth: TREND_TOOLTIP_MAX_WIDTH,
        width: 'max-content',
      }}
    >
      <OrgTrendsLineTooltipContent {...contentProps} />
    </Tooltip>
  );
}
